import { Component, ViewChild } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { DesktopService } from "../../../providers/desktop-service";
import { DirectoryService } from "../../../providers/directory-service";
import { Page } from "ionic-angular/navigation/nav-util";
import { BlankDesktopPage } from "../blank/blank";

@Component({
    selector: 'split-view-page',
    templateUrl: 'split-view.html',
})
export class SplitViewPage {
    private readonly initialLeftPanePage: Page;
    private readonly initialRightPanePage: Page;

    @ViewChild('left') private leftPane: NavController;
    @ViewChild('right') private rightPane: NavController;

    constructor(
        private desktopService: DesktopService,
        private navParams: NavParams,
        private directoryService: DirectoryService
    ) {
        this.initialLeftPanePage = navParams.get('leftPane');
        this.initialRightPanePage = navParams.get('RightPane');
    }

    public async ionViewWillEnter() {
        if (this.initialLeftPanePage) {
            await this.leftPane.setRoot(this.initialLeftPanePage);
        }

        if (this.initialRightPanePage) {
            await this.rightPane.setRoot(this.initialRightPanePage);
        } else {
            await this.rightPane.setRoot(BlankDesktopPage);
        }

        this.desktopService.setLeftPane(this.leftPane);
        this.desktopService.setRightPane(this.rightPane);

        this.directoryService.setNavCtrl(this.desktopService.getLeftPane());
    }
}



// WEBPACK FOOTER //
// ./src/pages/desktop/split-view/split-view.ts